/**
 * useFormFields.js
 * New hook — extracts the identical `set(key) => (e) => setFields(...)`
 * pattern that was copy-pasted in both LoginPanel.js and SignupPanel.js.
 */

import { useState } from "react";

export function useFormFields(initial) {
    const [fields, setFields] = useState(initial);

    const set = (key) => (e) =>
        setFields((prev) => ({ ...prev, [key]: e.target.value }));

    const setField = (key, value) =>
        setFields((prev) => ({ ...prev, [key]: value }));

    return { fields, set, setField, setFields };
}
